(function () {
    'use strict';
    var m = angular.module('viewer', [
        'utils',
        'common'
    ]);
}());